import commonEn from './common/en.json';
import commonZhHant from './common/zh-Hant.json';
import commonTh from './common/th.json';
import commonVi from './common/vi.json';

export default {
  en: commonEn,
  'zh-Hant': commonZhHant,
  vi: commonVi,
  th: commonTh,
};
